import { render } from "./ServiceFormModal.vue?vue&type=template&id=65415548"
import script from "./ServiceFormModal.vue?vue&type=script&lang=js"
export * from "./ServiceFormModal.vue?vue&type=script&lang=js"

import exportComponent from "/builds/phi-indonesia/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__